module.exports = __webpack_public_path__ + "static/media/details-16-image-1.5b3eb707.jpg";